import React, { createContext, useContext, useCallback, useEffect, useRef } from 'react';

const DataCacheContext = createContext();

// Clave del antiguo caché en sessionStorage; se elimina para no dejar datos viejos
const LEGACY_STORAGE_KEY = 'meli_data_cache';

// Sin caché: cada llamada va al backend. Se mantiene la misma API para no
// tocar las páginas que la consumen.
export const DataCacheProvider = ({ children }) => {
  const pendingRequests = useRef({});

  useEffect(() => {
    try {
      sessionStorage.removeItem(LEGACY_STORAGE_KEY);
    } catch {}
  }, []);

  const getStaleCache = useCallback(() => null, []);

  const invalidateCache = useCallback(() => {}, []);

  const fetchWithCache = useCallback(async (cacheKey, fetchFn) => {
    // Evitar llamadas duplicadas simultáneas (solo mientras la petición está en curso)
    if (pendingRequests.current[cacheKey]) {
      return pendingRequests.current[cacheKey];
    }

    const requestPromise = (async () => {
      try {
        return await fetchFn();
      } finally {
        delete pendingRequests.current[cacheKey];
      }
    })();

    pendingRequests.current[cacheKey] = requestPromise;
    return requestPromise;
  }, []);

  const value = {
    fetchWithCache,
    getStaleCache,
    invalidateCache,
  };

  return (
    <DataCacheContext.Provider value={value}>
      {children}
    </DataCacheContext.Provider>
  );
};

export const useDataCache = () => {
  const context = useContext(DataCacheContext);
  if (!context) {
    throw new Error('useDataCache must be used within DataCacheProvider');
  }
  return context;
};

export default DataCacheContext;
